// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__U-L-J","aside__profile":"Aside_aside__profile__xP+Gm","aside__container":"Aside_aside__container__ekL+S"};